import type { FC, ReactNode } from 'react'

import { Logo } from '@/components/generals/logo'
import { siteConfig } from '@/constants/site'
import { NAV_LINKS } from '@/constants/landing'

const linkClassName = 'rounded-md text-sm text-muted-foreground outline-none transition-colors hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/50'

export const SiteFooter: FC = (): ReactNode => {
    const year = new Date().getFullYear()

    return (
        <footer className='border-t border-border bg-white'>
            <div className='mx-auto max-w-6xl px-5 py-14 sm:px-6 lg:px-8'>
                <div className='grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr]'>
                    <div className='sm:col-span-2 lg:col-span-1'>
                        <Logo />

                        <p className='mt-4 max-w-xs text-sm leading-relaxed text-muted-foreground'>
                            The ERP that shows your business at a glance, from today&apos;s quotations to who signed in.
                        </p>
                    </div>

                    <nav aria-labelledby='footer-product'>
                        <h2 id='footer-product' className='text-sm font-semibold text-foreground'>
                            Product
                        </h2>

                        <ul className='mt-4 space-y-3'>
                            {NAV_LINKS.map(link => (
                                <li key={link.href}>
                                    <a href={link.href} className={linkClassName}>
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <nav aria-labelledby='footer-start'>
                        <h2 id='footer-start' className='text-sm font-semibold text-foreground'>
                            Get started
                        </h2>

                        <ul className='mt-4 space-y-3'>
                            <li>
                                <a href='/#demo' className={linkClassName}>
                                    Book a demo
                                </a>
                            </li>

                            <li>
                                <a href={siteConfig.appUrl} className={linkClassName}>
                                    Sign in
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <div className='mt-12 flex flex-col gap-2 border-t border-border pt-6 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between'>
                    <p>
                        &copy; <span suppressHydrationWarning>{year}</span> {siteConfig.name}. All rights reserved.
                    </p>

                    <p>
                        Sign in with your mobile number and PIN.
                    </p>
                </div>
            </div>
        </footer>
    )
}
